import { render, staticRenderFns } from "./ValueSolarWall.vue?vue&type=template&id=a3572ff0&scoped=true"
import script from "./ValueSolarWall.vue?vue&type=script&lang=js"
export * from "./ValueSolarWall.vue?vue&type=script&lang=js"
import style0 from "./ValueSolarWall.vue?vue&type=style&index=0&id=a3572ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3572ff0",
  null
  
)

export default component.exports